import { createBrowserRouter } from "react-router";

export const RouterPrivate = createBrowserRouter([
	{
		path: "/",
		lazy: () => import("../routes/root"),
		HydrateFallback: () => null,
		children: [
			{
				index: true,
				lazy: () => import("../routes/_index"),
			},
			{
				lazy: () => import("../routes/app-layout"),
				children: [
					{
						path: "app-admin/trial-settings",
						lazy: () =>
							import("../routes/app-admin.trial-settings._index/route"),
					},
					{
						path: "app-admin/apartment-sets",
						lazy: () =>
							import("../routes/app-admin.apartment-sets._index/route"),
					},
					{
						path: "app-admin/autodesk-exports",
						lazy: () =>
							import("../routes/app-admin.autodesk-exports._index/route"),
					},
					{
						path: "billing",
						lazy: () => import("../routes/billing._index/route"),
					},
					{
						path: "cookies",
						lazy: () => import("../routes/cookies._index/route"),
					},
					{
						path: "impressum",
						lazy: () => import("../routes/impressum._index/route"),
					},
					{
						path: "org/apartment-sets",
						lazy: () => import("../routes/org.apartment-sets._index/route"),
					},
					{
						path: "privacy",
						lazy: () => import("../routes/privacy._index/route"),
					},
					{
						path: "project",
						lazy: () => import("../routes/project._index/route"),
					},
					{
						path: "terms",
						lazy: () => import("../routes/terms._index/route"),
					},
				],
			},
			{
				path: "project/new",
				lazy: () => import("../routes/project.new/route"),
			},
			{
				path: "project/:projectId",
				lazy: () => import("../routes/project.$projectId/route"),
				children: [
					{
						path: "layout/:layoutId",
						lazy: () =>
							import("../routes/project.$projectId.layout.$layoutId/route"),
					},
					{
						path: "layout/:layoutId/json",
						lazy: () =>
							import(
								"../routes/project.$projectId.layout.$layoutId.json/route"
							),
					},
				],
			},
			{
				path: "*",
				lazy: () => import("../routes/$"),
			},
		],
	},
]);
